<dt>
  <div class="wysiwyg-content">{{{content}}}</div>
</dt>
